import {
    APP_ROOT_URI,
    IMS_STAGE_ENV,
    PL_ALL_TOPICS,
    PL_CREATION_FIELDS,
    PLAYLIST_STATUS,
    LOCALE_SHORTCODE,
} from './content-production';

import logo_adobe from '../../assets/productlogos/logo_adobe.png';
import logo_sg_illustrator_1_1 from '../../assets/productlogos/logo_sg_illustrator_1_1.png';
import logo_sg_photoshop_1_1 from '../../assets/productlogos/logo_sg_photoshop_1_1.png';
import logo_sg_premierepro_1_1 from '../../assets/productlogos/logo_sg_premierepro_1_1.png';
import logo_sg_indesign_1_1 from '../../assets/productlogos/logo_sg_indesign_1_1.png';
import logo_sg_adobeaero from '../../assets/productlogos/logo_sg_adobeaero.png';
import logo_sg_aftereffects_1_1 from '../../assets/productlogos/logo_sg_aftereffects_1_1.png';
import logo_sg_animate from '../../assets/productlogos/logo_sg_animate.png';
import logo_sg_audition_1_1 from '../../assets/productlogos/logo_sg_audition_1_1.png';
import logo_sg_bridge_1_1 from '../../assets/productlogos/logo_sg_bridge_1_1.png';
import logo_sg_creativecloud from '../../assets/productlogos/logo_sg_creativecloud.png';
import logo_sg_characteranimator from '../../assets/productlogos/logo_sg_characteranimator.png';
import logo_sg_dimension from '../../assets/productlogos/logo_sg_dimension.png';
import logo_sg_dreamweaver_1_1 from '../../assets/productlogos/logo_sg_dreamweaver_1_1.png';
import logo_sg_fresco from '../../assets/productlogos/logo_sg_fresco.png';
import logo_sg_mediaencoder_pk from '../../assets/productlogos/logo_sg_mediaencoder_pk.png';

import logo_sg_photoshopexpress from '../../assets/productlogos/logo_sg_photoshopexpress.png';
import logo_sg_lightroom_1_1_cc from '../../assets/productlogos/logo_sg_lightroom_1_1_cc.png';
import logo_sg_lightroom_1_1_classic from '../../assets/productlogos/LTRM.png';
import logo_sg_rush from '../../assets/productlogos/logo_sg_lightroom_1_1_classic.png';
import logo_sg_speedgrade from '../../assets/productlogos/logo_sg_speedgrade.png';
import logo_sg_adobestock from '../../assets/productlogos/logo_sg_adobestock.png';

import logo_sg_substance_painter from '../../assets/productlogos/logo_sg_substance_painter.png';
import logo_sg_substance_designer from '../../assets/productlogos/logo_sg_substance_designer.png';
import logo_sg_substance_sampler from '../../assets/productlogos/logo_sg_substance_sampler.png';
import logo_sg_substance_3d_stager from '../../assets/productlogos/logo_sg_substance_3d_stager.png';
import logo_sg_substance_3d_modeler from '../../assets/productlogos/logo_sg_substance_3d_modeler.png';

import logo_sg_xd from '../../assets/productlogos/logo_sg_xd.png';
import logo_sg_acrobat_dc from '../../assets/productlogos/logo_sg_acrobat_dc.png';
import logo_sg_cc_express from '../../assets/productlogos/logo_sg_cc_express.svg';
import logo_sg_firefly from '../../assets/productlogos/logo_sg_firefly.svg';

import placeholder_hero from '../../assets/previews/placeholder.hero.164x119.png';
import placeholder_thumbnail from '../../assets/previews/placeholder.thumbnail.40x40.png';

import * as CONST from './content-production';

// SG code is missing for Photoshop Camera and queries currently return no ututs/pls/cls
// import logo_PCAM from "../../assets/productlogos/PCAM.png";

import Asset from '../../classes/Asset';
import _ from 'lodash';

export const getAppURIPath = (pathName: string): string => {
    return `${APP_ROOT_URI}/${pathName}`;
};

export const isDarkMode = () => {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
};

export const isIMSStageEnvironment = () => {
    return process.env.IMS_ENV === IMS_STAGE_ENV;
};

// LCP-1849 - net storage does not allow special or localized characters in file names, check before uploading
export const isValidAssetName = (assetName): boolean => {
    const allowedCharsRegex = new RegExp(/[^-_.a-zA-Z0-9 ]/, 'g');
    return !allowedCharsRegex.test(assetName);
};

export const getPLApplication = (
    appCode: string,
    additionalProducts: any[],
): { fi_code: string[]; sap_code: string[] } => {
    let addOns: any = [appCode];
    additionalProducts.map((addProduct: any) => {
        addOns = [...addOns, addProduct.id ?? addProduct];
    });

    // remove duplicates
    addOns = _.uniq(addOns);

    let fi_code: any = [];
    let sap_code: any = [];
    addOns.forEach((element) => {
        switch (element) {
            case 'ACRS':
                if (sap_code.indexOf('ACRS') === -1) {
                    fi_code = [...fi_code, 'acrobat_dc_pro'];
                    sap_code = [...sap_code, 'ACRS'];
                }
                break;
            case 'AEFT':
                if (sap_code.indexOf('AEFT') === -1) {
                    fi_code = [...fi_code, 'aftereffects_cc'];
                    sap_code = [...sap_code, 'AEFT'];
                }
                break;
            case 'CCEX':
                if (sap_code.indexOf('CCEX') === -1) {
                    fi_code = [...fi_code, 'free_spark'];
                    sap_code = [...sap_code, 'CCEX'];
                }
                break;
            case 'FFLY':
                if (sap_code.indexOf('FFLY') === -1) {
                    fi_code = [...fi_code, 'firefly_credits'];
                    sap_code = [...sap_code, 'FFLY'];
                }
                break;
            case 'IDSN':
                if (sap_code.indexOf('IDSN') === -1) {
                    fi_code = [...fi_code, 'indesign_cc'];
                    sap_code = [...sap_code, 'IDSN'];
                }
                break;
            case 'ILST':
                if (sap_code.indexOf('ILST') === -1) {
                    fi_code = [...fi_code, 'illustrator_cc'];
                    sap_code = [...sap_code, 'ILST'];
                }
                break;
            case 'LPES':
                if (sap_code.indexOf('LPES') === -1) {
                    fi_code = [...fi_code, 'lightroom_cc'];
                    sap_code = [...sap_code, 'LPES'];
                }
                break;
            case 'LTRM':
                if (sap_code.indexOf('LTRM') === -1) {
                    fi_code = [...fi_code, 'lightroom_cc'];
                    sap_code = [...sap_code, 'LTRM'];
                }
                break;
            case 'PHSP':
                if (sap_code.indexOf('PHSP') === -1) {
                    fi_code = [...fi_code, 'photoshop_cc'];
                    sap_code = [...sap_code, 'PHSP'];
                }
                break;
            case 'PPRO':
                if (sap_code.indexOf('PPRO') === -1) {
                    fi_code = [...fi_code, 'premierepro_cc'];
                    sap_code = [...sap_code, 'PPRO'];
                }
                break;
            case 'SBSTD':
                if (sap_code.indexOf('SBSTD') === -1) {
                    fi_code = [...fi_code, 'sbst_designer'];
                    sap_code = [...sap_code, 'SBSTD'];
                }
                break;
            case 'SHPR':
                if (sap_code.indexOf('SHPR') === -1) {
                    fi_code = [...fi_code, 'sbst_shaper'];
                    sap_code = [...sap_code, 'SHPR'];
                }
                break;
            case 'SBSTP':
                if (sap_code.indexOf('SBSTP') === -1) {
                    fi_code = [...fi_code, 'sbst_painter'];
                    sap_code = [...sap_code, 'SBSTP'];
                }
                break;
            case 'SBSTA':
                if (sap_code.indexOf('SBSTA') === -1) {
                    fi_code = [...fi_code, 'sbst_alchemist'];
                    sap_code = [...sap_code, 'SBSTA'];
                }
                break;
            case 'STGR':
                if (sap_code.indexOf('STGR') === -1) {
                    fi_code = [...fi_code, 'sbst_stager'];
                    sap_code = [...sap_code, 'STGR'];
                }
                break;
        }
    });

    return { fi_code, sap_code };
};

const topicName = (topics) => {
    return topics.map((topic) => {
        return topic.enName ?? topic.name;
    });
};
export const isLive = (status) => (status.toLowerCase() === 'draft' ? false : true);

export const getNewPL = (data) => {
    const newPL = {};
    const images = {};
    const taxonomy = {};
    taxonomy['creative_fields'] = [...data['creativeFields']];
    taxonomy['topics'] = [...data['topics']];
    images['thumbnail'] = data?.['thumbnailImage'] ?? '';
    images['hero'] = data?.['heroImage'] ?? '';
    newPL['playlistUUID'] = data['upsertType'] !== 'Create' ? data['playlistUUID'] : '';
    newPL['id'] = data['upsertType'] !== 'Create' ? data['id'] : data['nonEngDuplicate'] ? data['id'] : '';
    // : "";
    newPL['aem_id'] = data['aem_id'];
    newPL['locale'] = data['locale'];
    newPL['status'] = data['status'];
    newPL['title'] = data['locale'] === 'en_US' ? data['title'] : data['nonEngTitle'];
    newPL['description'] = data['desc'];
    newPL['formatVersion'] = data['formatVersion'];
    newPL['type'] = data['type'];
    newPL['applications'] = getPLApplication(data['primaryProduct'], data['addProducts']);
    if (data['products']?.length) {
        newPL['products'] = [];
        data['products'].forEach((product: any) => {
            // only add on valid input selection
            if (product.sapCode) {
                product.fiCode = getFiCodeFromSapCode(product.sapCode);
                delete product.id;
                delete product.type;
                // add all non-empty values
                newPL['products'].push(_.omitBy(product, _.isEmpty));
            }
        });
    } else {
        newPL['products'] = [];
        newPL['applications']['sap_code'].forEach((sapCode: string) => {
            newPL['products'].push({
                sapCode,
                fiCode: getFiCodeFromSapCode(sapCode),
            });
        });
    }

    newPL['images'] = images;
    newPL['level'] = data['experienceLevel'];
    newPL['platforms'] = [data['surface']];
    newPL['creative_fields'] = topicName(data['creativeFields']);
    newPL['creative_categories'] = [data['creativeCategory']];
    newPL['topics'] = topicName(data['topics']);
    newPL['taxonomy'] = taxonomy;
    newPL['total_duration'] = 0;
    newPL['created_on'] = data['created_on'];
    newPL['text'] = '';
    newPL['source'] = {
        third_party: false,
        label: 'Adobe.com',
    };

    newPL['stage'] = data['learnStage'];
    newPL['playlist_stage'] = data['playlistStage'];
    newPL['tutorial_ids'] = data['tutorial_ids'];
    newPL['utut_metadata'] = [];
    newPL['header'] = '';
    /*
  "media": {
    "renditions": [
      {
        "url": "adobetv.com/123",
        "type": "video/x-adobe-mpc" // value "mpc" might change
      }
    ]
  }
  */
    let renditions: any[] = [];
    if (data['mpcVideoUrl'] != undefined && data['mpcVideoUrl'] != '') {
        renditions.push({ url: data['mpcVideoUrl'], type: 'video/x-adobe-mpc' });
    }
    if (data?.heroAltAsset != undefined) {
        let hAlt: Asset = data?.heroAltAsset!;
        renditions.push(hAlt.rendition);
    }
    if (data?.thumbnailAltAsset != undefined) {
        let tbAlt: Asset = data?.thumbnailAltAsset!;
        renditions.push(tbAlt.rendition);
    }

    if (renditions.length > 0) {
        newPL['media'] = { renditions: renditions };
    }

    return newPL;
};

export const getNewCL = (data) => {
    console.log('Data===>', data);
    const newPL = {};
    const images = {};
    const taxonomy = {};
    taxonomy['creative_fields'] = [...data['creativeFields']];
    taxonomy['topics'] = [...data['topics']];
    images['thumbnail'] = data?.['thumbnailImage'] ?? '';
    images['hero'] = data?.['heroImage'] ?? '';
    newPL['id'] = data['upsertType'] !== 'Create' ? (data['id'] !== '' ? data['id'] : '') : '';
    newPL['aem_id'] = data['aem_id'];
    newPL['locale'] = data['locale'];
    newPL['status'] = data['status'];
    newPL['title'] = data['locale'] === 'en_US' ? data['title'] : data['nonEngTitle'];
    newPL['description'] = data['desc'];
    newPL['goal'] = data['goal'];
    newPL['applications'] = getPLApplication(data['primaryProduct'], data['addProducts']);
    newPL['images'] = images;
    newPL['level'] = data['experienceLevel'];
    //newPL["platforms"] = [data["surface"]];
    newPL['creative_fields'] = topicName(data['creativeFields']);
    newPL['topics'] = topicName(data['topics']);
    newPL['collection_stage'] = data['collectionStage'];
    newPL['taxonomy'] = taxonomy;
    newPL['total_duration'] = 0;
    newPL['created_on'] = data['created_on'];
    newPL['source'] = {
        third_party: false,
        label: 'Adobe.com',
    };

    newPL['useCase'] = data['useCase'];
    newPL['playlist_ids'] = data['playlist_ids'];
    newPL['playlist_metadata'] = [];
    newPL['sections'] = data['sections'];
    //newPL["header"] = "";

    return newPL;
};

/**
 * getImageSrc: get surface image
 * @param appCode
 */
export const getImageSrc = (appCode) => {
    if (appCode && appCode !== '') {
        appCode = appCode.toUpperCase();
        switch (appCode) {
            case 'ADOBE':
                return logo_adobe;
            case 'AID':
            case 'ILST':
                return logo_sg_illustrator_1_1;
            case 'PHSP_MBL':
            case 'PSD':
            case 'PSW':
            case 'PHSP':
                return logo_sg_photoshop_1_1;
            case 'PPRO':
                return logo_sg_premierepro_1_1;
            case 'IDSN':
                return logo_sg_indesign_1_1;
            case 'AERO':
                return logo_sg_adobeaero;
            case 'AEFT':
                return logo_sg_aftereffects_1_1;
            case 'FLPR':
                return logo_sg_animate;
            case 'AUDT':
                return logo_sg_audition_1_1;
            case 'KBRG':
                return logo_sg_bridge_1_1;
            case 'ACR':
                return '';
            case 'ANML':
                return logo_sg_characteranimator;
            case 'CCSN':
                return logo_sg_creativecloud;
            case 'ESHR':
                return logo_sg_dimension;
            case 'DRWV':
                return logo_sg_dreamweaver_1_1;
            case 'TKIT':
                return '';
            case 'FRSC':
                return logo_sg_fresco;
            case 'AME':
                return logo_sg_mediaencoder_pk;
            case 'PSX':
                return logo_sg_photoshopexpress;
            case 'LPES':
                return logo_sg_lightroom_1_1_cc;
            case 'LTRM':
                return logo_sg_lightroom_1_1_classic;
            case 'RUSH':
                return logo_sg_rush;
            case 'SPGD':
                return logo_sg_speedgrade;
            case 'STOK':
                return logo_sg_adobestock;
            case 'SBST':
                return '';
            case 'SBSTP':
                return logo_sg_substance_painter;
            case 'SBSTD':
                return logo_sg_substance_designer;
            case 'SBSTA':
                return logo_sg_substance_sampler;
            case 'STGR':
                return logo_sg_substance_3d_stager;
            case 'SHPR':
                return logo_sg_substance_3d_modeler;
            case 'SPRK':
                return logo_sg_xd;
            case 'ACRS':
                return logo_sg_acrobat_dc;
            case 'CCX':
            case 'CCEX':
                return logo_sg_cc_express;
            case 'FFLY':
                return logo_sg_firefly;
        }
    } else {
        return '';
    }
};

export const getAppName = (sapCode) => {
    switch (sapCode) {
        case 'ACRS':
            return 'acrobat';
        case 'IDSN':
            return 'indesign';
        case 'ILST':
            return 'illustrator';
        case 'PHSP':
            return 'photoshop';
        case 'PPRO':
            return 'premiere-pro';
        case 'AEFT':
            return 'after-effects';
        case 'CCEX':
            return 'express';
        case 'LPES':
            return 'lightroom-cc';
        case 'LTRM':
            return 'lightroom-classic';
        case 'FFLY':
            return 'firefly';
        case 'SBSTD':
            return 'substance-3d-designer';
        case 'SHPR':
            return 'substance-3d-modeler';
        case 'SBSTP':
            return 'substance-3d-painter';
        case 'SBSTA':
            return 'substance-3d-sampler';
        case 'STGR':
            return 'substance-3d-stager';
    }
};

export const formatPlaylistTags = (data, fieldName): string[] => {
    const totalList =
        fieldName === 'CREATIVE_FIELDS'
            ? data.data.data.data.tags.creative_fields
            : fieldName === 'TOPICS'
              ? data.data.data.data.tags.topics
              : [];

    let res: any = [];
    totalList.map((data) => {
        const ele: any = { ...data };
        delete ele?.['apps'];
        res = [...res, ele];
    });

    return res;
};

/**
 * capitalizeFirstLetter: Capitalize the first letter
 * @param {string} str It is selected locale
 */
export const capitalizeFirstLetter = (str) => {
    return str && str !== '' ? str[0].toUpperCase() + str.substring(1) : '';
};

export function secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? ' hour, ' : ' hours, ') : '';
    var mDisplay = m > 0 ? m + (m == 1 ? ' minute, ' : ' minutes, ') : '';
    var sDisplay = s > 0 ? s + (s == 1 ? ' second' : ' seconds') : '';
    const rel = hDisplay + mDisplay + sDisplay;
    return rel ? rel.replace(/,\s*$/, '') : rel;
}

/**
 * If one of the selected utut is draft then then only draft playlist
 * @param selectedUtuts
 * @param playlistStatus
 */
export const getPlaylistStatusBySelectedUtuts = (selectedUtuts: any, playlistStatus: string) => {
    let status = playlistStatus;
    selectedUtuts.forEach((selectedUtut) => {
        if (selectedUtut?.status === PLAYLIST_STATUS.DRAFT) {
            status = PLAYLIST_STATUS.DRAFT;
            return;
        }
    });
    return status;
};

export const formatAddProducts = (applications) => {
    const totalList = CONST.PL_CREATION_PRIMARY_PRODUCT;
    let rel: any = [];
    applications.map((application) => {
        for (let i = 0; i < totalList.length; i++) {
            if (totalList[i]['id'] === application) {
                rel = [...rel, totalList[i]];
            }
        }
    });
    return rel;
};

export const copyValueToClipboard = (value) => {
    navigator.clipboard.writeText(value);
};

export const PL_ALL_TOPICS_PS = PL_ALL_TOPICS;
export const PL_CREATION_FIELDS_PS = PL_CREATION_FIELDS;

const PHOTOSHOP_LOCALES: LOCALE_SHORTCODE[] = [
    LOCALE_SHORTCODE.cs_CZ,
    LOCALE_SHORTCODE.da_DK,
    LOCALE_SHORTCODE.de_DE,
    LOCALE_SHORTCODE.es_ES,
    LOCALE_SHORTCODE.fi_FI,
    LOCALE_SHORTCODE.fr_FR,
    LOCALE_SHORTCODE.hu_HU,
    LOCALE_SHORTCODE.id_ID,
    LOCALE_SHORTCODE.it_IT,
    LOCALE_SHORTCODE.ja_JP,
    LOCALE_SHORTCODE.ko_KR,
    LOCALE_SHORTCODE.nb_NO,
    LOCALE_SHORTCODE.nl_NL,
    LOCALE_SHORTCODE.pl_PL,
    LOCALE_SHORTCODE.pt_BR,
    LOCALE_SHORTCODE.ru_RU,
    LOCALE_SHORTCODE.sv_SE,
    LOCALE_SHORTCODE.th_TH,
    LOCALE_SHORTCODE.tr_TR,
    LOCALE_SHORTCODE.uk_UA,
    LOCALE_SHORTCODE.vi_VN,
    LOCALE_SHORTCODE.zh_CN,
    LOCALE_SHORTCODE.zh_TW,
];

// AiD currently does not support Indonesian, Thai, and Vietnamese locales
const ILLUSTRATOR_LOCALES: LOCALE_SHORTCODE[] = [
    LOCALE_SHORTCODE.cs_CZ,
    LOCALE_SHORTCODE.da_DK,
    LOCALE_SHORTCODE.de_DE,
    LOCALE_SHORTCODE.es_ES,
    LOCALE_SHORTCODE.fi_FI,
    LOCALE_SHORTCODE.fr_FR,
    LOCALE_SHORTCODE.hu_HU,
    LOCALE_SHORTCODE.it_IT,
    LOCALE_SHORTCODE.ja_JP,
    LOCALE_SHORTCODE.ko_KR,
    LOCALE_SHORTCODE.nb_NO,
    LOCALE_SHORTCODE.nl_NL,
    LOCALE_SHORTCODE.pl_PL,
    LOCALE_SHORTCODE.pt_BR,
    LOCALE_SHORTCODE.ru_RU,
    LOCALE_SHORTCODE.sv_SE,
    LOCALE_SHORTCODE.tr_TR,
    LOCALE_SHORTCODE.uk_UA,
    LOCALE_SHORTCODE.zh_CN,
    LOCALE_SHORTCODE.zh_TW,
];

const EXPRESS_LOCALES: LOCALE_SHORTCODE[] = [
    LOCALE_SHORTCODE.fr_FR,
    LOCALE_SHORTCODE.de_DE,
    LOCALE_SHORTCODE.ja_JP,
    LOCALE_SHORTCODE.ko_KR,
    LOCALE_SHORTCODE.it_IT,
    LOCALE_SHORTCODE.es_ES,
    LOCALE_SHORTCODE.pt_BR,
    LOCALE_SHORTCODE.da_DK,
    LOCALE_SHORTCODE.nl_NL,
    LOCALE_SHORTCODE.nb_NO,
    LOCALE_SHORTCODE.sv_SE,
    LOCALE_SHORTCODE.fi_FI,
    LOCALE_SHORTCODE.zh_CN,
    LOCALE_SHORTCODE.zh_TW,
    LOCALE_SHORTCODE.cy_GB,
    LOCALE_SHORTCODE.tr_TR,
    LOCALE_SHORTCODE.pl_PL,
    LOCALE_SHORTCODE.ro_RO,
    LOCALE_SHORTCODE.el_GR,
    LOCALE_SHORTCODE.hi_IN,
    LOCALE_SHORTCODE.bn_IN,
    LOCALE_SHORTCODE.ta_IN,
    LOCALE_SHORTCODE.fil_PH,
    LOCALE_SHORTCODE.ms_MY,
    LOCALE_SHORTCODE.id_ID,
    LOCALE_SHORTCODE.th_TH,
];

export interface Application {
    applicationName: string;
    sgCode: string;
    sapCode: string;
    fiCode: string;
    applicationLogo: string | null;
    // optional - aem app path, eg. PL creation for firefly -> `playlist/firefly/myfireflyplaylist`
    aemIdentifier?: string;
    // optional - list of locales which are allowed for localization requests
    allowedLocalisations?: LOCALE_SHORTCODE[];
}

export const APPLICATIONS: Application[] = [
    {
        applicationName: 'Acrobat DC',
        sgCode: 'SG_ACROBAT_DC',
        sapCode: 'ACRS',
        fiCode: 'acrobat_dc_pro',
        applicationLogo: logo_sg_acrobat_dc,
    },
    {
        applicationName: 'Aero',
        sgCode: 'SG_ADOBEAERO',
        sapCode: 'AERO',
        fiCode: 'aero_cc',
        applicationLogo: logo_sg_adobeaero,
    },
    {
        applicationName: 'After Effects',
        sgCode: 'SG_AFTEREFFECTS_1_1',
        sapCode: 'AEFT',
        fiCode: 'aftereffects_cc',
        applicationLogo: logo_sg_aftereffects_1_1,
    },
    {
        applicationName: 'Animate',
        sgCode: 'SG_ANIMATE',
        sapCode: 'FLPR',
        fiCode: 'flash_professional_cc',
        applicationLogo: logo_sg_animate,
    },
    {
        applicationName: 'Audition',
        sgCode: 'SG_AUDITION_1_1',
        sapCode: 'AUDT',
        fiCode: 'audition_cc',
        applicationLogo: logo_sg_audition_1_1,
    },
    {
        applicationName: 'Bridge',
        sgCode: 'SG_BRIDGE_1_1',
        sapCode: 'KBRG',
        fiCode: 'bridge_cc',
        applicationLogo: logo_sg_bridge_1_1,
    },
    {
        applicationName: 'Camera Raw',
        sgCode: 'SG_CAMERARAW',
        sapCode: 'ACR',
        fiCode: '',
        applicationLogo: null,
    },
    {
        applicationName: 'Character Animator',
        sgCode: 'SG_CHARACTERANIMATOR',
        sapCode: 'ANML',
        fiCode: 'characteranimator_cc',
        applicationLogo: logo_sg_characteranimator,
    },
    {
        applicationName: 'Creative Cloud',
        sgCode: 'SG_CREATIVECLOUD',
        sapCode: 'CCSN',
        fiCode: 'cc_storage',
        applicationLogo: logo_sg_creativecloud,
    },
    {
        applicationName: 'Dimension',
        sgCode: 'SG_DIMENSION',
        sapCode: 'ESHR',
        fiCode: 'dimension_cc',
        applicationLogo: logo_sg_dimension,
    },
    {
        applicationName: 'Dreamweaver',
        sgCode: 'SG_DREAMWEAVER_1_1',
        sapCode: 'DRWV',
        fiCode: 'dreamweaver_cc',
        applicationLogo: logo_sg_dreamweaver_1_1,
    },
    {
        applicationName: 'Express',
        sgCode: 'SG_CC_EXPRESS',
        sapCode: 'CCEX',
        fiCode: 'free_spark',
        applicationLogo: logo_sg_cc_express,
        aemIdentifier: 'express',
        allowedLocalisations: [...EXPRESS_LOCALES],
    },
    {
        applicationName: 'Firefly',
        sgCode: 'SG_FIREFLY',
        sapCode: 'FFLY',
        fiCode: 'firefly_credits',
        applicationLogo: logo_sg_firefly,
        aemIdentifier: 'firefly',
    },
    {
        applicationName: 'Fonts',
        sgCode: 'SG_TYPEKIT',
        sapCode: 'TKIT',
        fiCode: '',
        applicationLogo: null,
    },
    {
        applicationName: 'Fresco',
        sgCode: 'SG_FRESCO',
        sapCode: 'FRSC',
        fiCode: 'fresco',
        applicationLogo: logo_sg_fresco,
    },
    {
        applicationName: 'Illustrator',
        sgCode: 'SG_ILLUSTRATOR_1_1',
        sapCode: 'ILST',
        fiCode: 'illustrator_cc',
        applicationLogo: logo_sg_illustrator_1_1,
        aemIdentifier: 'illustrator',
        allowedLocalisations: [...ILLUSTRATOR_LOCALES],
    },
    {
        applicationName: 'Illustrator on the Web',
        sgCode: 'SG_ILLUSTRATOR_WEB',
        sapCode: 'ILST',
        fiCode: 'illustrator_web',
        applicationLogo: logo_sg_illustrator_1_1,
    },
    {
        applicationName: 'InDesign',
        sgCode: 'SG_INDESIGN_1_1',
        sapCode: 'IDSN',
        fiCode: 'indesign_cc',
        applicationLogo: logo_sg_indesign_1_1,
        aemIdentifier: 'indesign',
    },
    {
        applicationName: 'Lightroom',
        sgCode: 'SG_LIGHTROOM_1_1/cc',
        sapCode: 'LPES',
        fiCode: 'lightroom_cc',
        applicationLogo: logo_sg_lightroom_1_1_cc,
    },
    {
        applicationName: 'Lightroom Classic',
        sgCode: 'SG_LIGHTROOM_1_1/classic',
        sapCode: 'LTRM',
        fiCode: 'lightroom_cc',
        applicationLogo: logo_sg_lightroom_1_1_classic,
    },
    {
        applicationName: 'Media Encoder',
        sgCode: 'SG_MEDIAENCODER_PK',
        sapCode: 'AME',
        fiCode: 'adobe_media_encoder',
        applicationLogo: logo_sg_mediaencoder_pk,
    },
    {
        applicationName: 'Photoshop',
        sgCode: 'SG_PHOTOSHOP_1_1',
        sapCode: 'PHSP',
        fiCode: 'photoshop_cc',
        applicationLogo: logo_sg_photoshop_1_1,
        aemIdentifier: 'photoshop',
        allowedLocalisations: [...PHOTOSHOP_LOCALES],
    },
    {
        applicationName: 'Photoshop Express',
        sgCode: 'SG_PHOTOSHOPEXPRESS',
        sapCode: 'PSX',
        fiCode: '',
        applicationLogo: logo_sg_photoshopexpress,
    },
    {
        applicationName: 'Photoshop on the Web',
        sgCode: 'SG_PHOTOSHOP_WEB',
        sapCode: 'PHSP',
        fiCode: 'photoshop_web',
        applicationLogo: logo_sg_photoshop_1_1,
        allowedLocalisations: [...PHOTOSHOP_LOCALES],
    },
    {
        applicationName: 'Premiere Pro',
        sgCode: 'SG_PREMIEREPRO_1_1',
        sapCode: 'PPRO',
        fiCode: 'premierepro_cc',
        applicationLogo: logo_sg_premierepro_1_1,
    },
    {
        applicationName: 'Premiere Rush',
        sgCode: 'SG_RUSH',
        sapCode: 'RUSH',
        fiCode: 'premiere_rush_cc',
        applicationLogo: logo_sg_rush,
    },
    {
        applicationName: 'SpeedGrade',
        sgCode: 'SG_SPEEDGRADE',
        sapCode: 'SPGD',
        fiCode: '',
        applicationLogo: logo_sg_speedgrade,
    },
    {
        applicationName: 'Stock',
        sgCode: 'SG_ADOBESTOCK',
        sapCode: 'STOK',
        fiCode: 'ctsk_direct_indirect_team',
        applicationLogo: logo_sg_adobestock,
    },
    {
        applicationName: 'Substance 3D Designer',
        sgCode: 'SG_SUBSTANCE_DESIGNER',
        sapCode: 'SBSTD',
        fiCode: 'sbst_designer',
        applicationLogo: logo_sg_substance_designer,
        aemIdentifier: 'substance-3d-designer',
    },
    {
        applicationName: 'Substance 3D Modeler',
        sgCode: 'SG_SUBSTANCE_3D_MODELER',
        sapCode: 'SHPR',
        fiCode: 'sbst_shaper',
        applicationLogo: logo_sg_substance_3d_modeler,
        aemIdentifier: 'substance-3d-modeler',
    },
    {
        applicationName: 'Substance 3D Painter',
        sgCode: 'SG_SUBSTANCE_PAINTER',
        sapCode: 'SBSTP',
        fiCode: 'sbst_painter',
        applicationLogo: logo_sg_substance_painter,
        aemIdentifier: 'substance-3d-painter',
    },
    {
        applicationName: 'Substance 3D Sampler',
        sgCode: 'SG_SUBSTANCE_SAMPLER',
        sapCode: 'SBSTA',
        fiCode: 'sbst_alchemist',
        applicationLogo: logo_sg_substance_sampler,
        aemIdentifier: 'substance-3d-sampler',
    },
    {
        applicationName: 'Substance 3D Stager',
        sgCode: 'SG_SUBSTANCE_3D_STAGER',
        sapCode: 'STGR',
        fiCode: 'sbst_stager',
        applicationLogo: logo_sg_substance_3d_stager,
        aemIdentifier: 'substance-3d-stager',
    },
    {
        applicationName: 'XD',
        sgCode: 'SG_XD',
        sapCode: 'SPRK',
        fiCode: 'xd_cc',
        applicationLogo: logo_sg_xd,
    },
];

interface ApplicationFilter {
    label: string;
    value: string;
}

/**
 *  Returns an array for application dropdowns [previously appList], including 'all' option
 *   [{
 *    label: "lcp.common.allApps",
 *    value: "all",
 *   },
 *   {
 *     label: "Photoshop",
 *     value: "PHSP",
 *   }, ...]
 *
 */
export const getApplicationFilterList = (): ApplicationFilter[] => {
    let result: ApplicationFilter[] = [];

    result.push({
        label: 'lcp.common.allApps',
        value: 'all',
    });

    APPLICATIONS.forEach((application) => {
        if (application.applicationName && application.sapCode) {
            result.push({
                label: application.applicationName,
                value: application.sgCode,
            });
        }
    });

    return result;
};

/**
 * Returns the Application matching the SG code
 *
 * @param sgCode
 */
export const getApplicationFromSgCode = (sgCode: string = ''): Application | null => {
    if (!sgCode) return null;
    const result = APPLICATIONS.find((application) => {
        return application.sgCode === sgCode;
    });
    return result ?? null;
};

/**
 * Returns the Application matching both SAP and FI code
 *
 * @param sapCode
 * @param fiCode
 */
export const getApplicationFromSapAndFiCode = (sapCode: string = '', fiCode: string = ''): Application | null => {
    if (!sapCode || !fiCode) return null;
    const result = APPLICATIONS.find((product) => {
        return product.sapCode === sapCode && product.fiCode === fiCode;
    });
    return result ?? null;
};

export const getApplicationFromSapCode = (sapCode: string = ''): Application | null => {
    if (!sapCode) return null;
    const result = APPLICATIONS.find((product) => {
        return product.sapCode === sapCode;
    });
    return result ?? null;
};

export const getFiCodeFromSapCode = (sapCode: string): string => {
    const application = getApplicationFromSapCode(sapCode);
    return application?.fiCode ?? '';
};

export const TBW_USER_GUIDE_URL = 'https://adobe.ly/tbwuserguide';
export const CP_USER_GUIDE_URL = '';
export const UM_USER_GUIDE_URL = '';

export const getPlaceholderHero = () => {
    return placeholder_hero;
};

export const getPlaceholderThumbnail = () => {
    return placeholder_thumbnail;
};

/**
 * Taxonomy tag item from playlist/collection tags API (creative_fields, topics).
 * Use this type instead of Record<string, unknown> when handling taxonomy data.
 */
export interface TaxonomyTag {
    id: string;
    internalId?: string;
    name?: string;
    enName?: string;
}

/**
 * Tags object at data.data.data.data.tags in playlist tags API response.
 * Same shape is used in playlist/collection response.taxonomy.
 */
export interface TaxonomyTags {
    creative_fields?: TaxonomyTag[];
    topics?: TaxonomyTag[];
}

/** Tags object at data.data.data.data.tags in playlist tags API response. */
const getPlaylistTags = (data: Record<string, unknown>): TaxonomyTags | undefined => {
    const nested = data as { data?: { data?: { data?: { tags?: TaxonomyTags } } } };
    return nested?.data?.data?.data?.tags;
};

/**
 * Returns creative fields as full options for dropdowns (id + name).
 * Use this for the Creative field options list; use formatPlaylistTags when you only need IDs.
 */
export const getCreativeFieldsOptions = (
    data: Record<string, unknown>,
): Array<{ id: string; internalId?: string; name: string; enName?: string }> => {
    const list = getPlaylistTags(data)?.creative_fields ?? [];
    return list.map((t) => ({
        id: t.id,
        internalId: t.internalId,
        name: t.name ?? t.enName ?? t.id,
        enName: t.enName ?? t.name,
    }));
};

/**
 * Returns topics as full options for the Tags component (id, name, enName).
 * Use this for the Learn topics list so suggestions show labels; use formatPlaylistTags when you only need IDs.
 */
export const getTopicsOptions = (
    data: Record<string, unknown>,
): Array<{ id: string; internalId?: string; name: string; enName?: string }> => {
    const list = getPlaylistTags(data)?.topics ?? [];
    return list.map((t) => ({
        id: t.id,
        internalId: t.internalId,
        name: t.name ?? t.enName ?? t.id,
        enName: t.enName ?? t.name,
    }));
};

/** Shape expected by AuthorizationService.checkPlaylistPermissions / checkCollectionPermissions */
export type PermissionResourceItem = {
    aem_id: string;
    status: string;
    locale: string;
    applications: { sap_code: string[]; fi_code: string[] };
};

const toStrArray = (v: unknown): string[] =>
    Array.isArray(v) ? v.filter((s): s is string => s != null && s !== '') : v != null && v !== '' ? [v as string] : [];

/**
 * Format a playlist or collection item (dashboard row or search hit) for permission API.
 * Normalizes applications from item.applications or item.sap_code + item.fi_code.
 */
export function formatItemForPermissionCheck(item: Record<string, unknown>): PermissionResourceItem {
    const applications = item['applications'] as { sap_code?: unknown; fi_code?: unknown } | undefined;
    let apps: { sap_code: string[]; fi_code: string[] };
    if (applications && [applications.sap_code, applications.fi_code].every((v) => v != null)) {
        const sap = toStrArray(applications.sap_code);
        const fi = toStrArray(applications.fi_code);
        apps = sap.length && fi.length ? { sap_code: sap, fi_code: fi } : { sap_code: [''], fi_code: [''] };
    } else if ([item['sap_code'], item['fi_code']].every((v) => v != null)) {
        const sap = toStrArray(item['sap_code']);
        const fi = toStrArray(item['fi_code']);
        apps = sap.length && fi.length ? { sap_code: sap, fi_code: fi } : { sap_code: [''], fi_code: [''] };
    } else {
        apps = { sap_code: [''], fi_code: [''] };
    }
    return {
        aem_id: (item['aem_id'] ?? (item['_metadata'] as Record<string, unknown> | undefined)?.aem_id ?? '') as string,
        status: (item['status'] ?? '') as string,
        locale: (item['locale'] ?? '') as string,
        applications: apps,
    };
}
